import type { EveMessage } from 'eve/vue'

export interface DocueAgentTextBlock {
  stepIndex?: number
  text: string
}

export function docueAgentMessageTextBlocks(message: EveMessage): DocueAgentTextBlock[] {
  const blocks: DocueAgentTextBlock[] = []

  for (const part of message.parts) {
    if (part.type !== 'text')
      continue

    const previous = blocks.at(-1)
    if (previous && previous.stepIndex === part.stepIndex) {
      previous.text += part.text
    }
    else {
      blocks.push({
        stepIndex: part.stepIndex,
        text: part.text,
      })
    }
  }

  return blocks.filter(block => block.text.trim())
}
